module.exports = "/static/media/ios.6baa5a0f.svg";